import { resolveAuthenticatedHeaders } from '@/utils/requestContext.js';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

const buildHeaders = () => {
  return resolveAuthenticatedHeaders({
    'Content-Type': 'application/json',
  });
};

const request = async (url, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      ...buildHeaders(),
      ...(options.headers || {}),
    },
  });
  const data = await response.json();
  if (!response.ok || data.ok === false) {
    throw new Error(data.error || data.message || 'Error inesperado en numeraciones');
  }
  return data.data ?? data;
};

export const listNumeraciones = (filters = {}) => {
  const query = new URLSearchParams();
  if (filters.sucursal_id) query.set('sucursal_id', filters.sucursal_id);
  if (filters.tipo_documento) query.set('tipo_documento', filters.tipo_documento);
  return request(`/api/numeraciones?${query.toString()}`);
};

export const getCatalogosNumeraciones = (sucursalId) => {
  const query = sucursalId ? `?sucursal_id=${sucursalId}` : '';
  return request(`/api/numeraciones/meta/catalogos${query}`);
};

export const createNumeracion = (payload) =>
  request('/api/numeraciones', { method: 'POST', body: JSON.stringify(payload) });

export const updateNumeracion = (id, payload) =>
  request(`/api/numeraciones/${id}`, { method: 'PUT', body: JSON.stringify(payload) });

export const toggleNumeracion = (id, activo) =>
  request(`/api/numeraciones/${id}/estado`, {
    method: 'PATCH',
    body: JSON.stringify({ activo }),
  });
